import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { map } from 'rxjs/operators';

import { AuthService } from 'app/core/services/auth/auth.service';
import { BaseAuthService } from 'app/core/services/base-auth.service';

import { NewspaperPdf } from 'app/shared/components/newspapers-pdf/shared/model/newspaper-pdf.model';
import { Observable } from 'rxjs';

@Injectable()
export class ArchiveService extends BaseAuthService {
  constructor(public authService: AuthService, public http: HttpClient) {
    super(http, authService);
  }

  getArchive(parameters: Object) {
    return this.get('archive', {...parameters, auth_tokens: true}).pipe(
      map(archives => archives[0].map(archive => NewspaperPdf.fromObject(archive)))
    );
  }

  getCalameoUrlForIframe(url: string): Observable<{ link: string }> {
    return this.http.get<{ link: string }>(url);
  }
}
